<template>
  <div class="mt-4">
    <h4>{{ $t('message.roomDetails') }}</h4>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="RoomNumber">{{ $t('message.roomNumber') }}</label>
        <input
          v-validate="'required'"
          id="RoomNumber"
          :disabled="isAmadeous"
          v-model="editModel.RoomNumber"
          name="Room Number"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Room Number") }}</div>
      </div>
    </div>
    <div v-if="!isAmadeous" class="form-row">
      <div class="form-group col-md-6">
        <label for="First Name">{{ $t('message.firstName') }}</label>
        <input
          v-validate="'required'"
          id="FirstName"
          v-model="editModel.FirstName"
          @change="syncFirstName(editModel.FirstName)"
          name="First Name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("First Name") }}</div>
      </div>
      <div class="form-group col-md-6">
        <label for="Last Name">{{ $t('message.lastName') }}</label>
        <input
          v-validate="'required'"
          id="LastName"
          v-model="editModel.LastName"
          name="Last Name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Last Name") }}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="EmailAddress">{{ $t('message.emailAddress') }}</label>
        <input
          v-validate="'required|email'"
          id="EmailAddress"
          v-model="editModel.Email"
          name="Email Address"
          type="email"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Email Address") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoomDelivery",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isAmadeous() {
      if (this.$route.query.room || localStorage.getItem("room")) {
        return true;
      }
      return false;
    }
  },
  methods: {
    syncFirstName(firstName) {
      if (this.$parent.syncFirstName) this.$parent.syncFirstName(firstName);
    },
    validate() {
      return this.$validator.validateAll();
    }
  }
};
</script>
